export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/containers/index.ts